import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { paymentFollowUpSchema } from './schemas';

export const useStartPaymentFollowUp = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data: paymentFollowUp } = await fetchJson(`/invoices/${id}/payment-follow-up`, {
        method: 'POST',
        schema: apiResourceSchema(paymentFollowUpSchema),
      });

      return paymentFollowUp;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.index.root });
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.show.history(id) });

      return queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.show.id(id), exact: true });
    },
  });
};
